module.exports = __webpack_public_path__ + "static/media/powerscourt.e2b336d0.png";